import { render } from "./ResetPass.vue?vue&type=template&id=4bac2fb8&scoped=true"
import script from "./ResetPass.vue?vue&type=script&lang=js"
export * from "./ResetPass.vue?vue&type=script&lang=js"

import "./ResetPass.vue?vue&type=style&index=0&id=4bac2fb8&scoped=true&lang=css"
import "./ResetPass.vue?vue&type=style&index=1&id=4bac2fb8&scoped=true&lang=css"

import exportComponent from "D:\\Shivani\\myProjects\\p2p_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bac2fb8"]])

export default __exports__